/**
 * Created by Teo on 03/05/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('custom-procedures', {
                parent: 'admin',
                url: '/custom-procedures',
                data: {
                    authorities: ['ROLE_SYSTEM'],
                    pageTitle: 'Διαδικασίες'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/custom-procedures/custom-procedures.html',
                        controller: 'CustomProceduresController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
